import { auth } from './auth';
import { clients } from './clients';
import { common } from './common';
import { community } from './community';
import { creditnotes } from './creditnotes';
import { dashboard } from './dashboard';
import { filters } from './filters';
import { forum } from './forum';
import { invitations } from './invitations';
import { invoices } from './invoices';
import { invoiceTemplates } from './invoiceTemplates';
import { jobPosts } from './jobPosts';
import { lines } from './lines';
import { pricing } from './pricing';
import { products } from './products';
import { quotations } from './quotations';
import { settings } from './settings';
import { validation } from './validation';

export const english = {
  auth,
  clients,
  common,
  community,
  creditnotes,
  dashboard,
  filters,
  forum,
  invitations,
  invoices,
  invoiceTemplates,
  jobPosts,
  lines,
  pricing,
  products,
  validation,
  quotations,
  settings,
};
